import { Language, toLanguageFromLocale, Locale, localeTldMap } from '@peloton/internationalize';

var toDefaultLocale = function toDefaultLocale(pelotonPlatform) {
  switch (pelotonPlatform) {
    case 'sky_tv':
      return Locale.EnglishUnitedKingdom;

    default:
      return Locale.EnglishUnitedStates;
  }
};

export var getLocale = function getLocale(pelotonPlatform) {
  var _window, _window$navigator;

  var defaultLocale = toDefaultLocale(pelotonPlatform); // In the unlikely event we're generating a value outside of the browser, (SSR, SSG)
  // provide a best-guess default value depending on which app is calling this

  if (typeof window === 'undefined') return defaultLocale;
  var browserLocale = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.language; // If a locale is not set, return the default

  if (!browserLocale) return defaultLocale; // Only return the browser locale if its suppported by Peloton

  if (Object.values(Locale).includes(browserLocale)) return browserLocale; // If the locale is not supported but the language is German,
  // make sure to display Germany German

  if (toLanguageFromLocale(browserLocale) === Language.German) {
    return Locale.GermanGermany;
  }

  return defaultLocale;
};
export var toGetLocale = function toGetLocale(pelotonPlatform) {
  return function () {
    return getLocale(pelotonPlatform);
  };
};
export var getTLD = function getTLD(locale) {
  return localeTldMap[locale];
};